import { render, staticRenderFns } from "./CallenderContainer.vue?vue&type=template&id=24640dfc&scoped=true"
import script from "./CallenderContainer.vue?vue&type=script&lang=js"
export * from "./CallenderContainer.vue?vue&type=script&lang=js"
import style0 from "./CallenderContainer.vue?vue&type=style&index=0&id=24640dfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24640dfc",
  null
  
)

export default component.exports